import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Text } from './ui/AppText';
import { useTheme } from '../contexts/ThemeContext';

// Gradiente PADRAO do cabecalho — mesmo do card "Questoes de Concurso" (MemoryCard
// da Home). E o padrao global: todas as telas que usam ScreenHeader sem passar
// `backgroundColor`/`gradient` recebem este gradiente.
export const HEADER_GRADIENT = ['#0F1029', '#24114D', '#180A35'];

// Cabecalho de detalhe reutilizavel (botao voltar + titulo centralizado).
// Cantos inferiores arredondados; por padrao usa HEADER_GRADIENT.
// Usado pelas telas internas que precisam do cabecalho global do app.
// Props opcionais: `subtitle` (linha secundaria sob o titulo), `backgroundColor`
// (forca cor solida, sobrescrevendo o gradiente padrao), `gradient` (array de
// cores p/ LinearGradient, sobrescreve o padrao), `rightIcon` (badge padrao
// a direita) e `right` (slot a direita customizado, ex.: o icone do cerebro).
const ScreenHeader = ({
  title,
  subtitle,
  onBack,
  right = null,
  rightIcon = null,
  rightIconStyle,
  rightStyle,
  centeredTitle = false,
  backgroundColor,
  gradient,
  style,
}) => {
  const { theme } = useTheme();
  const insets = useSafeAreaInsets();
  // Padrao = gradiente. `backgroundColor` (sem `gradient`) forca cor solida.
  const gradientColors = gradient || (backgroundColor ? null : HEADER_GRADIENT);
  const bg = backgroundColor || theme.colors.headerBackground;
  // paddingTop por safe-area (status bar real do device) + respiro de 8 —
  // mesmo calculo do Header da Home, p/ os cabecalhos baterem em altura.
  const topPad = { paddingTop: insets.top + 8 };

  const titleBlock = (
    <View style={[styles.titleContainer, centeredTitle && styles.titleContainerCentered]}>
      <Text style={styles.headerTitle} numberOfLines={1}>{title}</Text>
      {subtitle ? (
        <Text style={styles.headerSubtitle} numberOfLines={1}>{subtitle}</Text>
      ) : null}
    </View>
  );

  const rightContent = rightIcon ? (
    <View style={[styles.rightIconContainer, rightIconStyle]}>
      <Text style={styles.rightIconText}>{rightIcon}</Text>
    </View>
  ) : right;

  const content = (
    <View style={[styles.headerTop, centeredTitle && styles.headerTopCentered]}>
      {onBack ? (
        <TouchableOpacity style={styles.backButton} onPress={onBack}>
          <Text style={styles.backIcon}>←</Text>
        </TouchableOpacity>
      ) : (
        <View style={styles.backButton} />
      )}
      {titleBlock}
      <View style={[styles.headerRight, rightStyle]}>{rightContent}</View>
    </View>
  );

  if (gradientColors) {
    return (
      <LinearGradient
        colors={gradientColors}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={[styles.header, topPad, style]}
      >
        {content}
      </LinearGradient>
    );
  }

  return (
    <View style={[styles.header, topPad, { backgroundColor: bg }, style]}>
      {content}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingBottom: 6,
    paddingHorizontal: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
  },
  headerTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTopCentered: {
    position: 'relative',
  },
  backButton: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(255,255,255,0.15)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    fontSize: 20,
    color: '#FFFFFF',
  },
  titleContainer: {
    flex: 1,
    alignItems: 'center',
  },
  titleContainerCentered: {
    position: 'absolute',
    left: 52,
    right: 52,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  headerSubtitle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'rgba(255,255,255,0.7)',
    marginTop: 2,
  },
  headerRight: {
    width: 40,
    alignItems: 'flex-end',
  },
  rightIconContainer: {
    width: 34,
    height: 34,
    borderRadius: 17,
    backgroundColor: 'rgba(91, 143, 249, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightIconText: {
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: '700',
  },
});

export default ScreenHeader;
